import { nativeApi as api } from './nativeHttp';

// Auth endpoints
export const authApi = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  me: () => api.get('/auth/me'),
};

// User endpoints
export const userApi = {
  getAll: () => api.get('/users'),
  getById: (id) => api.get(`/users/${id}`),
  update: (id, data) => api.put(`/users/${id}`, data),
  updateApiKey: (id, data) => api.put(`/users/${id}/api-key`, data),
  listAiKeys: (id) => api.get(`/users/${id}/ai-keys`),
  createAiKey: (id, data) => api.post(`/users/${id}/ai-keys`, data),
  updateAiKey: (id, keyId, data) => api.put(`/users/${id}/ai-keys/${keyId}`, data),
  deleteAiKey: (id, keyId) => api.delete(`/users/${id}/ai-keys/${keyId}`),
  delete: (id) => api.delete(`/users/${id}`),
};

// Exercise endpoints
export const exerciseApi = {
  getAll: (params) => api.get('/exercises', { params }),
  getById: (id) => api.get(`/exercises/${id}`),
  create: (data) => api.post('/exercises', data),
  update: (id, data) => api.put(`/exercises/${id}`, data),
  delete: (id) => api.delete(`/exercises/${id}`),
};

// Workout endpoints
export const workoutApi = {
  getAll: () => api.get('/workouts'),
  getById: (id) => api.get(`/workouts/${id}`),
  create: (data) => api.post('/workouts', data),
  ensureDefaults: () => api.post('/workouts/ensure-defaults'),
  applySuggestion: (data) => api.post('/workouts/apply-suggestion', data),
  completeSession: (id) => api.post(`/workouts/${id}/complete-session`),
  update: (id, data) => api.put(`/workouts/${id}`, data),
  delete: (id) => api.delete(`/workouts/${id}`),
};

// Series endpoints
export const seriesApi = {
  getAll: (params) => api.get('/series', { params }),
  getById: (id) => api.get(`/series/${id}`),
  create: (data) => api.post('/series', data),
  update: (id, data) => api.put(`/series/${id}`, data),
  delete: (id) => api.delete(`/series/${id}`),
};

// Evaluation endpoints
export const evaluationApi = {
  getAll: (params) => api.get('/evaluations', { params }),
  getById: (id) => api.get(`/evaluations/${id}`),
  create: (data) => api.post('/evaluations', data),
  update: (id, data) => api.put(`/evaluations/${id}`, data),
  delete: (id) => api.delete(`/evaluations/${id}`),
};

// IA endpoints
export const iaApi = {
  getEngines: () => api.get('/ia/engines'),
  initializeEngines: () => api.post('/ia/engines/initialize'),
  getHistory: (params) => api.get('/ia/history', { params }),
  suggestWorkout: (data) => api.post('/ia/workout-suggestion', data || {}),
  preSession: (data) => api.post('/ia/pre-session', data || {}),
};

export default api;
